export enum ApmMessage {
  FORM_ERROR = "Form validation error",
  PAYMENT_ERROR = "Payment url error"
}
